import React, { PureComponent, PropTypes } from 'react';
import cn from 'classnames';

import styles from './styles.scss';

export class Clockin extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          version="1.1"
          id="Clock_Ins"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 363.2 63.8"
          preserveAspectRatio="xMinYMin meet"
        >
          <g>
            <path
              className={styles.st0}
              d="M353.9,60.1H8.3c-2.3,0-4.2-1.9-4.2-4.2V14.3c0-2.3,1.9-4.2,4.2-4.2h345.5c2.3,0,4.2,1.9,4.2,4.2v41.6C358.1,58.2,356.2,60.1,353.9,60.1z"
            />
            <path
              className={styles.st1}
              d="M353.9,54.3H8.7c-2.3,0-4.2-1.9-4.2-4.2V8.5c0-2.3,1.9-4.2,4.2-4.2h345.1c2.3,0,4.2,1.9,4.2,4.2v41.6C358.1,52.4,356.2,54.3,353.9,54.3z"
            />
          </g>
          <path
            className={styles.st2}
            d="M61.4,13.1v32.4c0,1.4-1.1,2.5-2.5,2.5H26.5c-1.4,0-2.5-1.1-2.5-2.5V13.1c0-1.4,1.1-2.5,2.5-2.5h32.4C60.3,10.6,61.4,11.7,61.4,13.1z"
          />
          <g>
            <g>
              <path
                className={styles.st3}
                d="M38.7,47.3c-0.2,0.3-0.4,0.5-0.6,0.7h-5.7c-0.6-0.6-1-1.4-1.1-2.2c-0.1-0.5-0.1-1.1,0.1-1.7c0.1-0.4,0.2-0.7,0.5-1.1c1.2-1.9,3.6-2.5,5.5-1.3C39.3,42.9,39.9,45.4,38.7,47.3z"
              />
            </g>
            <g>
              <path
                className={styles.st4}
                d="M54.2,48h-23l0.1-2.2l0-1.2c0-0.2,0-0.3,0-0.5c0.2-1.3,1-2.4,2.1-2.8l3.3-1.2l1.5-0.5l0.1,0c0,0,0.1,0,0.1,0c0.3,0.1,0.6-0.6,0.9-1.5c0.1-0.4,0.2-0.8,0.4-1.2c0.4-1.1,0.8-2.1,1.2-2.1h3.2c0.5,0,0.9,1.1,1.3,2.2c0.1,0.4,0.3,0.8,0.4,1.2c0.3,0.9,0.6,1.6,0.9,1.3l0.1,0l0.1,0l1.7,0.6h0l3.3,1.2c1.2,0.4,2.1,1.8,2.1,3.3L54.2,48z"
              />
            </g>
            <g>
              <path
                className={styles.st3}
                d="M46.9,34.3v6.1c0,2.3-2,3.4-4.4,3.4c-2.4,0-4.2-1.1-4.2-3.4v-6.1c0-2.3,1.9-4.1,4.3-4.1c1.2,0,2.3,0.5,3,1.2C46.5,32.1,46.9,33.1,46.9,34.3z"
              />
            </g>
            <g className={styles.st5}>
              <path
                className={styles.st6}
                d="M46.9,34.3v3.3c-1.2,0.8-2.7,1.2-4.2,1.2c-1.6,0-3.1-0.5-4.4-1.4v-3.2c0-2.3,1.9-4.1,4.3-4.1c1.2,0,2.3,0.5,3,1.2C46.5,32.1,46.9,33.1,46.9,34.3z"
              />
            </g>
            <g>
              <path
                className={styles.st6}
                d="M50.6,24.1v5.6c0,4.3-3.5,7.8-7.8,7.8c-4.3,0-7.8-3.5-7.8-7.8v-5.6c0-2.7,1.4-5.1,3.5-6.5c0.7-0.5,1.5-0.8,2.3-1c0.6-0.2,1.3-0.3,2-0.3c2.2,0,4.1,0.9,5.5,2.3c1.2,1.2,2.1,2.9,2.2,4.7C50.5,23.6,50.6,23.8,50.6,24.1z"
              />
            </g>
            <g>
              <circle className={styles.st6} cx="50.6" cy="27.7" r="1.8" />
            </g>
            <g>
              <circle className={styles.st6} cx="34.9" cy="27.7" r="1.8" />
            </g>
            <g>
              <circle className={styles.st7} cx="39.2" cy="27.6" r="1" />
            </g>
            <g>
              <circle className={styles.st7} cx="46.2" cy="27.6" r="1" />
            </g>
            <g className={styles.st5}>
              <path
                className={styles.st3}
                d="M42.6,34c-1.5,0-2.8-0.8-3.5-2.1c-0.1-0.2,0-0.5,0.2-0.6c0.2-0.1,0.5,0,0.6,0.2c0.6,1,1.6,1.7,2.8,1.7c1.2,0,2.2-0.6,2.8-1.7c0.1-0.2,0.4-0.3,0.6-0.2c0.2,0.1,0.3,0.4,0.2,0.6C45.5,33.2,44.1,34,42.6,34z"
              />
            </g>
            <g>
              <path className={styles.st8} d="M37.9,39l4.6,4.8l-1.3,2.4L36.7,40c0-0.1,0-0.1,0-0.2l1-0.9C37.8,38.9,37.9,38.9,37.9,39z" />
            </g>
            <g>
              <path className={styles.st8} d="M47.4,39l-4.7,4.8l1.4,2.4l4.7-6.2c0-0.1,0-0.2,0-0.2L47.6,39C47.5,38.9,47.4,38.9,47.4,39z" />
            </g>
            <g className={styles.st9}>
              <rect x="42.2" y="43.8" className={styles.st10} width="0.9" height="4.2" />
            </g>
            <g>
              <path
                className={styles.st7}
                d="M37.3,26c-0.2,0-0.3-0.2-0.3-0.4c0-0.2,0.1-0.4,0.4-0.5l2.6-0.3c0.2,0,0.4,0.1,0.5,0.4c0,0.2-0.1,0.4-0.4,0.5L37.4,26C37.4,26,37.4,26,37.3,26z"
              />
            </g>
            <g>
              <path
                className={styles.st11}
                d="M35.4,30.2c0.4,0,0.7-0.3,0.7-0.7v-4.7c0-2.3,1.1-4.4,3-5.6c0.6-0.4,1.2-0.7,1.9-0.9c0.5-0.1,1.1-0.2,1.7-0.2c1.8,0,3.5,0.7,4.7,2c1.1,1.1,1.8,2.5,1.9,4c0,0.2,0,0.5,0,0.7v4.7c0,0.4,0.3,0.7,0.7,0.7l0,0c0.4,0,0.7-0.3,0.7-0.7v-4.7c0-0.3,0-0.6,0-0.9c-0.2-1.9-1-3.6-2.3-4.8c-1.5-1.5-3.5-2.4-5.7-2.4c-0.7,0-1.4,0.1-2.1,0.3c-0.8,0.2-1.6,0.6-2.3,1c-2.2,1.4-3.7,3.9-3.7,6.8v4.7C34.7,29.8,35,30.2,35.4,30.2L35.4,30.2z"
              />
            </g>
            <g>
              <path
                className={styles.st7}
                d="M47.7,26c0,0-0.1,0-0.1,0L45,25.7c-0.2,0-0.4-0.2-0.4-0.5c0-0.2,0.2-0.4,0.5-0.4l2.6,0.3c0.2,0,0.4,0.2,0.4,0.5C48.1,25.8,47.9,25.9,47.7,26z"
              />
            </g>
            <g>
              <path
                className={styles.st12}
                d="M38,18.6c0,0-1.8-0.8-3.1,0.5c-1.3,1.3-1.8,3.1-1,5.2c0.4,1,0.5,0.9,0.5,0.9l0.8,1.2c0,0,0.6-4.2,2.3-5.8C38.2,20.1,38.4,19.3,38,18.6L38,18.6z"
              />
            </g>
            <g>
              <path className={styles.st13} d="M53.4,17.9c0,0,3.2,7.5-10.3,6.3c-7.1-0.6-7.3-3.8-7.3-3.8s1.3-7.7,7.3-5.6C53,18.3,53.4,17.9,53.4,17.9z" />
            </g>
            <g className={styles.st5}>
              <path
                className={styles.st3}
                d="M42.7,31.1c-0.2,0-0.4-0.1-0.4-0.3c-0.1-0.2,0.1-0.5,0.3-0.5c0.2-0.1,0.4-0.2,0.5-0.3c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.4-0.4-0.8-0.3c-0.2,0.1-0.5-0.1-0.5-0.3c-0.1-0.2,0.1-0.5,0.3-0.5c0.8-0.2,1.6,0.2,1.8,0.8c0.1,0.3,0,0.7-0.2,1c-0.2,0.3-0.5,0.5-0.9,0.6C42.7,31.1,42.7,31.1,42.7,31.1z"
              />
            </g>
          </g>
          <path
            className={styles.st14}
            d="M140.7,39.1H76c-0.7,0-1.2-0.5-1.2-1.2v-16c0-0.7,0.5-1.2,1.2-1.2h64.7c0.7,0,1.2,0.5,1.2,1.2v16C141.9,38.5,141.4,39.1,140.7,39.1z"
          />
          <path
            className={styles.st15}
            d="M294.9,39.1h-64.7c-0.7,0-1.2-0.5-1.2-1.2v-16c0-0.7,0.5-1.2,1.2-1.2h64.7c0.7,0,1.2,0.5,1.2,1.2v16C296.1,38.5,295.5,39.1,294.9,39.1z"
          />
          <path
            className={styles.st16}
            d="M181.6,39.1h-31.2c-0.7,0-1.2-0.5-1.2-1.2v-16c0-0.7,0.5-1.2,1.2-1.2h31.2c0.7,0,1.2,0.5,1.2,1.2v16C182.8,38.5,182.2,39.1,181.6,39.1z"
          />
          <path
            className={styles.st16}
            d="M218.8,39.1h-31.2c-0.7,0-1.2-0.5-1.2-1.2v-16c0-0.7,0.5-1.2,1.2-1.2h31.2c0.7,0,1.2,0.5,1.2,1.2v16C220,38.5,219.5,39.1,218.8,39.1z"
          />
          <g>
            <path
              className={styles.st16}
              d="M344.7,44.4h-35.2c-0.7,0-1.3-0.6-1.3-1.3V16.5c0-0.7,0.6-1.3,1.3-1.3h35.2c0.7,0,1.3,0.6,1.3,1.3v26.6C346,43.9,345.4,44.4,344.7,44.4z"
            />
            <g>
              <rect x="313.6" y="22.2" className={styles.st17} width="17.9" height="3.3" />
              <rect x="313.6" y="28.2" className={styles.st17} width="17.9" height="3.3" />
              <rect x="313.6" y="34.2" className={styles.st17} width="17.9" height="3.3" />
              <circle className={styles.st17} cx="338.2" cy="23.8" r="1.7" />
              <circle className={styles.st17} cx="338.2" cy="29.9" r="1.7" />
              <circle className={styles.st17} cx="338.2" cy="35.9" r="1.7" />
            </g>
          </g>
          <text transform="matrix(1 0 0 1 89.402 35.0438)" className={cn(styles.st18, styles.st19, styles.st20)}>8:00</text>
          <text transform="matrix(1 0 0 1 241.8122 35.0438)" className={cn(styles.st18, styles.st19, styles.st20)}>14:00</text>
          <text transform="matrix(1 0 0 1 152.7565 33.0419)" className={cn(styles.st21, styles.st19, styles.st22)}>10:00</text>
          <text transform="matrix(1 0 0 1 190.2087 33.1073)" className={cn(styles.st21, styles.st19, styles.st22)}>10:30</text>
        </svg>
      </div>
    );
  }
}

Clockin.propTypes = {
  className: PropTypes.string,
};

export default Clockin;



// WEBPACK FOOTER //
// ./src/components/shared/clockin/index.jsx